import React from 'react';

export const HammerSvg = (props) => {

  const { width, height, color } = props;

  return (
    <svg width={width ?? "16"} height={height ?? "16"} viewBox="0 0 16 16" fill={color ?? window?.settings?.secondary_color ?? '#04333b'} xmlns="http://www.w3.org/2000/svg">
      <path d="M8.10699 5.01343L0.373929 13.5446C0.373929 13.5446 -0.46796 14.6028 0.373929 15.6896C0.373929 15.6896 1.04744 16.47 2.52999 15.5507L9.75792 6.29637L8.10699 5.01343Z" />
      <path d="M13.2485 8.6579L11.6879 7.38722C11.6879 7.38722 12.1971 6.18599 10.8953 5.71613C10.8953 5.71613 9.93841 5.74881 9.76181 6.29631L8.10678 5.01337C8.10678 5.01337 8.95278 3.00724 7.59344 1.87139C7.59344 1.87139 6.75565 1.10734 5.6304 1.091C5.6304 1.091 4.59549 1.091 5.43327 0.469955C5.43327 0.469955 7.51541 -0.719013 10.0164 0.682417L12.9117 3.15024C12.9117 3.15024 12.8214 4.37598 13.499 4.44544L14.5503 4.40867L15.9056 5.54452C15.9056 5.54452 16.1027 5.68753 15.9056 5.86321L13.5688 8.58027C13.5729 8.58436 13.4497 8.82134 13.2485 8.6579Z" />
    </svg>

  )
}